export default "__VITE_ASSET__CLgnmB0x__"